import { ExtensionBase } from "./extensionBase";
import { viewerOptions } from "../viewer";
import { UiUtils } from "../common/uiUtils";

const STEP_SIZE = 2000;

/**
 * An extension that creates buttons for zooming in and out.
 */
export class ZoomExtension extends ExtensionBase {

    static extensionName = "ZoomExtension";
   
    private subToolbar: Autodesk.Viewing.UI.ControlGroup;

   
    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
    }

    static registerExtension() {
        super.registerExtension(ZoomExtension.extensionName, ZoomExtension);
    }

    load(): boolean {
        console.log(`${ZoomExtension.extensionName} is loaded!`);
        return super.load();
    };

    unload(): boolean {
        this.viewer.getToolbar(false).removeControl(this.subToolbar);
        return super.unload();
    };

    onToolbarCreated(): void {
        const fitButton = UiUtils.createButton({
            id: "SmartDrawings.FitToViewButton",
            tooltip: "Fit to view",
            iconClass: "ion-md-open",
            onClick: () => this.viewer.fitToView()
        });

        const plusButton = UiUtils.createButton({
            id: "SmartDrawings.ZoomInButton",
            tooltip: "Zoom in",
            iconClass: "ion-md-add",
            onClick: () => this.zoom(true)
    });

        const minusButton = UiUtils.createButton({
            id: "SmartDrawings.ZoomOutButton",
            tooltip: "Zoom out",
            iconClass: "ion-md-remove",
            onClick: () => this.zoom(false)
        });

        this.subToolbar = this.getControlGroup("SmartDrawings.NavExtensions");
        this.subToolbar.addControl(fitButton);
        this.subToolbar.addControl(plusButton);
        this.subToolbar.addControl(minusButton);
    }

    private zoom(zoomIn: boolean) {
        const nav = this.viewer.navigation;
        const pos = nav.getPosition();
        const target = nav.getTarget();
        const viewDir = new THREE.Vector3();

        viewDir.subVectors(pos, target).normalize();

        viewDir.multiplyScalar(zoomIn ? -STEP_SIZE : STEP_SIZE);
        pos.add(viewDir);
        nav.setPosition(pos);
    }

}